export interface TokenRecord {
  token: string;
  expiresAt: number;
}
